export class EventBus {
    constructor() {
        this.listeners = new Map();
    }
    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);
        return () => this.off(event, callback);
    }
    off(event, callback) {
        if (this.listeners.has(event)) {
            this.listeners.get(event).delete(callback);
        }
    }
    async emit(event, data) {
        if (this.listeners.has(event)) {
            const callbacks = Array.from(this.listeners.get(event));
            await Promise.all(callbacks.map(cb => {
                try {
                    return Promise.resolve(cb(data));
                }
                catch (e) {
                    console.error(`[EventBus] Error in listener for event "${event}":`, e);
                    return Promise.resolve();
                }
            }));
        }
    }
    clear() {
        this.listeners.clear();
    }
}
